import React, {useCallback, useContext, useEffect, useState} from 'react';
import {useParams} from "react-router-dom";
import {useTranslation} from "react-i18next";

import Grid from "@mui/material/Grid";
import Alert from "@mui/material/Alert";

import {OAuthContext} from "../../../context/OAuthContext";
import Filter from "../LeftFilter/Filter";
import PageLayout from "../../../layout/PageLayout";
import DetailsHeader from "./DetailsHeader/DetailsHeader";
import DetailsContent from "./DetailsContent/DetailsContent";
import DetailsFooter from "./DetailsFooter/DetailsFooter";
import FetchHelper from "../../Utils/helper";
import {ApplicationDetailsType, OpenActionModalType} from "./types";

const ApplicationDetails = () => {
    const {id} = useParams();
    const [applicationDetails, setApplicationDetails] = useState<ApplicationDetailsType | null>(null);
    const {oauthData} = useContext(OAuthContext);

    const {t} = useTranslation("common");

    const [editorIsMe, setEditorIsMe] = useState<boolean>(false);
    const [error, setError] = useState<boolean>(false);
    const [openModal, setOpenModal] = useState<OpenActionModalType>({
        note: false,
        decline: false,
        query: false,
        accept: false,
        history: false
    });

    const jwtData = oauthData.getJwtData();

    const handleOpenNoteForEdit = () => {
        setOpenModal(prevState => ({...prevState, note: true}))
    }

    const getDetails = useCallback(() => {
        const helper = new FetchHelper(oauthData.token)
        if (oauthData.token.accessToken && id) {
            helper.getApplicationDetails(id).then(details => setApplicationDetails(details)).catch(_ => setError(true))
        }
    }, [id, oauthData.token])

    useEffect(() => {
        getDetails();
    }, [getDetails])

    useEffect(() => {
        if (jwtData?.sub === applicationDetails?.editor?.employeeId.toString()) {
            setEditorIsMe(true);
            return;
        }
        setEditorIsMe(false)
    }, [jwtData?.sub, applicationDetails?.editor?.employeeId])

    if(error){
        return <PageLayout>
            <Grid container spacing={2}>
                <Grid item xs={2}>
                    <Filter/>
                </Grid>
                <Grid item xs={10}>
                    <Alert severity="error">{t("error_occurred")}</Alert>
                </Grid>
            </Grid>
        </PageLayout>
    }

    return (
        <PageLayout>
            <Grid container spacing={3} >
                <Grid item xs={3} md={2}>
                    <Filter/>
                </Grid>
                <Grid item xs={9} md={10}>
                    {applicationDetails && Object.entries(applicationDetails).length !== 0 && <>
                        <DetailsHeader
                            applicationDetails={applicationDetails}
                            openModal={openModal}
                            setOpenModal={setOpenModal}
                            applicationId={id}
                            setApplicationDetails={setApplicationDetails}
                            editorIsMe={editorIsMe}
                            setEditorIsMe={setEditorIsMe}/>

                        <DetailsContent details={applicationDetails} oauthData={oauthData}/>

                        <DetailsFooter applicationDetails={applicationDetails}
                                        editorIsMe={editorIsMe}
                                       handleOpenNoteForEdit={handleOpenNoteForEdit}
                                       oauthData={oauthData}
                        />
                    </>}
                </Grid>
            </Grid>
        </PageLayout>
    );
};

export default ApplicationDetails;